import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { target: String, delay: { type: Number, default: 500 } };

  connect() {
    setTimeout(() => {
      const targetElement = document.getElementById(this.targetValue);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }, this.delayValue);
  }
}
